import { Card, CardMedia, Button, Typography, Box } from "@mui/material";
import { ArrowOutward as ArrowOutwardIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const Blogcard = (props) => {
  const navigate = useNavigate();
  const { Title, bannerUrl, createdAt, description, blogDate } = props.blog;
  console.log("props ", props);

  return (
    <Box
      style={{
        borderRadius: "0.8rem",
        padding: "0.8rem",
        overflow: "hidden",
        height: "500px", // Fixed height for all cards
        display: "flex",
        flexDirection: "column",
        cursor: "pointer",
      }}
      onClick={() => {
          navigate(`${props.blog.slug}`, {
            state: { blogId: props.blog._id },
          });
        }}
    >
      {/* Banner Image */}
      <Box
        style={{
          width: "100%",
          height: "12rem",
          overflow: "hidden",
          borderRadius: "0.8rem",
          flexShrink: 0,
          backgroundColor: "#f2f2f2", // fallback bg color if no image
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {bannerUrl ? (
          <img
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
            src={bannerUrl}
            alt={Title}
          />
        ) : (
          <span style={{ color: "#888", fontSize: "0.9rem" }}>
            No Banner Available
          </span>
        )}
      </Box>

      <Box style={{ margin: "1rem 0 0.5rem 0", flexShrink: 0 }}>
        <Typography
          style={{
            fontFamily: "Montserrat, sans-serif",
            fontSize: "1.2rem",
            fontWeight: "600",
            lineHeight: "1.2",
            color: "#fff",
            display: "-webkit-box",
            WebkitLineClamp: 2, // Limit to 2 lines
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {Title}
        </Typography>
      </Box>

      <Box style={{ marginBottom: "1rem", flex: 1, overflow: "hidden" }}>
        {description && (
          <Typography
            style={{
              fontFamily: "Montserrat, sans-serif",
              fontSize: "1rem",
              fontWeight: "400",
              lineHeight: "1.5",
              color: "#e9eef7",
              display: "-webkit-box",
              WebkitLineClamp: 5,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {description}
          </Typography>
        )}
      </Box>

      <Box style={{ marginBottom: "1rem", flexShrink: 0 }}>
        <Typography
          style={{
            fontFamily: "Montserrat, sans-serif",
            fontSize: "0.8rem",
            fontWeight: "400",
            color: "#e9eef7",
          }}
        >
          Published on: {new Date(blogDate).toLocaleDateString()}
        </Typography>
      </Box>

      <Button
        variant="outlined"
        sx={{
          border: "1.2px solid white",
          color: "white",
          width: { xs: "140px", sm: "170px" },
          height: { xs: "38px", sm: "42px" },
          borderRadius: "50px",
          fontFamily: "DM Sans, Montserrat, sans-serif",
          fontSize: { xs: 12, sm: 14 },
          fontWeight: 400,
          alignSelf: { xs: "center", sm: "flex-start" },
          flexShrink: 0,
          "&:hover": {
            backgroundColor: "#fff",
            color: "#000",
            border: "1.2px solid #fff",
          },
          "& .MuiSvgIcon-root": {
            fontSize: { xs: 16, sm: 18 },
            marginLeft: "6px",
          },
        }}
        onClick={() => {
          navigate(`${props.blog.slug}`, {
            state: { blogId: props.blog._id },
          });
        }}
      >
        Read More <ArrowOutwardIcon />
      </Button>
    </Box>
  );
};

export default Blogcard;
